import { Tooltip, ThemeIcon } from "@mantine/core";
import { IconKey, IconKeyOff } from "@tabler/icons-react";

interface PortalAccessIndicatorProps {
  hasAccess: boolean;
  subjectLabel?: string;
}

export function PortalAccessIndicator({
  hasAccess,
  subjectLabel,
}: PortalAccessIndicatorProps) {
  const tooltip = hasAccess
    ? `${subjectLabel ?? "This"} has portal access`
    : `${subjectLabel ?? "This"} does not have portal access`;
  return (
    <Tooltip label={tooltip} withArrow>
      <ThemeIcon
        size="sm"
        variant="light"
        color={hasAccess ? "teal" : "gray"}
        radius="xl"
        aria-label={tooltip}
      >
        {hasAccess ? <IconKey size={12} /> : <IconKeyOff size={12} />}
      </ThemeIcon>
    </Tooltip>
  );
}
